const icons = require.context('./resources/svg', true, /\.svg$/);
const externalIcons = new Map();
window.sds = window.sds || {};
window.sds.initAdditionalSdsIcons = function (path, size, names) {
    names.forEach(name => externalIcons.set([name, size].toString(), path));
};
export function iconSrc(name, size) {
    return externalIcons.get([name, size].toString()) || icons(`./icons-${size}.svg`);
}
export function fileIconSrc(size) {
    return icons(`./file-icons-${size}.svg`);
}
